import { DirectionType, DistributionType } from "./Stack-types";
export {
  toFlexDirection,
  toFlexJustifyOrAlignment,
  paddingFromProps,
  makePaddingString,
};

function toFlexDirection(direction: DirectionType) {
  switch (direction) {
    case "vertical":
      return "column";
    case "horizontal":
      return "row-reverse";
    default:
      return "row";
  }
}

function toFlexJustifyOrAlignment(distribution: DistributionType) {
  switch (distribution) {
    case "start":
      return "flex-start";
    case "end":
      return "flex-end";
    default:
      return distribution;
  }
}

function paddingFromProps(props: any) {
  const {
    paddingPerSide,
    padding = 0,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
  } = props;
  if (
    paddingPerSide !== false &&
    (paddingTop !== undefined ||
      paddingBottom !== undefined ||
      paddingLeft !== undefined ||
      paddingRight !== undefined)
  ) {
    return {
      top: paddingTop !== undefined ? paddingTop : padding,
      bottom: paddingBottom !== undefined ? paddingBottom : padding,
      left: paddingLeft !== undefined ? paddingLeft : padding,
      right: paddingRight !== undefined ? paddingRight : padding,
    };
  }
  return {
    top: padding,
    bottom: padding,
    left: padding,
    right: padding,
  };
}

function makePaddingString({ top, left, bottom, right }: any) {
  return `${top}px ${right}px ${bottom}px ${left}px`;
}
